import { createSlice } from '@reduxjs/toolkit'

export const homeSlice = createSlice({
  name: 'home',
  initialState: {
    footerActiveTab: 1,
    showDrawer: false,
    showLoginMobileDrawer: false,
    showDownloadAppDrawer: false,
  },
  reducers: {
    setActiveFooterTab: (state, action) => {
      state.footerActiveTab = action.payload
    },
    setShowDrawer: (state, action) => {
      state.showDrawer = action.payload;
    },
    setShowLoginMobileDrawer: (state, action) => {
      state.showLoginMobileDrawer = action.payload;
    },
    setShowDownloadAppDrawer: (state, action) => {
      state.showDownloadAppDrawer = action.payload;
    },
  },
});


export const { setActiveFooterTab, setShowDrawer, setShowLoginMobileDrawer, setShowDownloadAppDrawer } = homeSlice.actions
export default homeSlice.reducer
